import BaseModal from "../BaseModal/BaseModal";
import GetUserInfo from "./get-user-info";
import {useEffect, useState} from "react";
import CreateCouponPayment from "./create-coupon-payment";


export default function BuyCouponCodeModal({className, isOpen, setOpen, ...props}) {
    const [paymentIntent, setPaymentIntent] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setPaymentIntent(null)
            setSuccess(false)
        }

    }, [isOpen])
    return (
        <BaseModal innerClassName={"lg:w-1/2 overflow-auto"} isBoxOpen={isOpen} autoClose={false} defaultHeader={true}
                   title={"Coupon Code"}
                   setIsBoxOpen={setOpen}>
            <div className={"p-4"}>
                {
                    paymentIntent === null ? (
                        <GetUserInfo
                            onComplete={(data) => {
                                setPaymentIntent(data)
                            }}
                        />
                    ) : !success ? (
                        <CreateCouponPayment
                            paymentIntent={paymentIntent}
                            onSucess={setSuccess}
                            setOpen={setOpen}
                        />
                    ) : (
                        <p>Success</p>
                    )

                }


            </div>
        </BaseModal>

    )
}